import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { Subject } from 'rxjs';
import { CommonService } from '../../Model/Common/common.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { DownloadSampleService } from '../../Model/DownloadSample/download-sample.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { CompanyPolicyMasterService } from '../../Model/CompanyDocument/company-policy-master.service';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-company-policy-master',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, DataTablesModule, LoaderComponent],
  templateUrl: './company-policy-master.component.html',
  styleUrl: './company-policy-master.component.scss'
})
export class CompanyPolicyMasterComponent {
  isDisabled: boolean = false;
  DetailDate = {
    SelectType: 'Delete',
    ESS_CompanyPolicyMasterID: 0 as any,
  }
  TableDatas = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    protected common: CommonService,
    private tooltip: TooltipService,
    private download: DownloadSampleService,
    private toast: ToastService,
    private companypolicy: CompanyPolicyMasterService,
    private modalService: NgbModal,
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.CompanyPolicyMaster();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  CompanyPolicyMaster() {
    this.isDisabled = true;
    this.companypolicy.CompanyPolicyMaster_Select({ SelectType: 1, ESS_CompanyPolicyMasterID: 0, OfficeType: '' }).subscribe({
      next: (response) => {
        this.TableDatas = Object.values(response.Table);
        this.TableDatas.forEach((element: any) => {
          element.WebESSApplicability = response.Table1.filter((e: any) => e.WebESSApplicabilityId == element.WebESSApplicabilityId)[0].ApplicabilityName
        });
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  LinkInTab(element: any) {
    if (element.IsTrainingVideo) {
      var url = element.TrainingURL
      if (url) {
        window.open(url, '_blank');
      }
      else {
        this.toast.show({ message: "No URL found!", type: toastTypeEnum.warning });
      }
    }
    else {
      var url = element.DocumentAttachmentLink;
      if (url) {
        window.open(url, '_blank');
      }
      else {
        this.toast.show({ message: "No URL found!", type: toastTypeEnum.warning });
      }
    }
  }
  deleteRow(ID: any) {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Are you sure want to delete this Policy?';
    modalRef.result.then(result => {
      this.DetailDate.ESS_CompanyPolicyMasterID = ID;
      if (this.common.PageRight.IsDelete) {
        if (result) {
          this.isDisabled = true;
          this.companypolicy.CompanyPolicyMaster_Insert(this.DetailDate).subscribe({
            next: (response) => {
              if (response.Error_Code == "01") {
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
                this.CompanyPolicyMaster();
              } else {
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    });
  }
}
